import { render, staticRenderFns } from "./ListShelterStatus.vue?vue&type=template&id=5dced6c2&"
import script from "./ListShelterStatus.vue?vue&type=script&lang=js&"
export * from "./ListShelterStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports